/* PB bundle bento: one live "bag + 9in sling + 7in wallet" thumbnail, shared by
   - the homepage bag finder (sections/pb-bag-finder.liquid paints its own markup through PBBento.paint)
   - the bag product pages (snippets/pb-bundle-bento.liquid, mode 'product': bundle choice + colour, cart add-ons)
   - collection cards (snippets/pb-bundle-bento.liquid, mode 'card': colour chips that swap the card photo)
   The bento is HTML, never a baked image: the bag tile follows the chosen variant, the sling and wallet tiles
   follow the chosen colour. Nothing loads until someone picks a bundle. */
(function () {
  if (window.PBBento) return;

  var CSS = '' +
    '.pb-bento{position:absolute;inset:0;z-index:4;display:grid;grid-template-columns:minmax(0,3fr) minmax(0,2fr);grid-template-rows:minmax(0,1fr) minmax(0,1fr);gap:6px;padding:6px;background:#fff;box-sizing:border-box}' +
    '.pb-bento[hidden],.pb-bento__t[hidden],.pb-bento__back[hidden]{display:none}' +
    '.pb-bento__t{position:relative;margin:0;min-width:0;min-height:0;border-radius:8px;background:#fff;box-shadow:inset 0 0 0 1px rgba(0,48,135,.14);overflow:hidden}' +
    '.pb-bento__t--bag{grid-row:1 / 3}' +
    '.pb-bento[data-n="1"] .pb-bento__t:not(.pb-bento__t--bag){grid-row:1 / 3}' +
    '.pb-bento .pb-bento__t img{position:absolute;inset:0;width:100%;height:100%;max-width:none;object-fit:contain;padding:5%;box-sizing:border-box;opacity:1}' +
    '.pb-bento .pb-bento__t--bag img{padding:3%}' +
    '.pb-bento__t figcaption{position:absolute;left:8px;top:6px;font-family:var(--font-mono,"Space Mono",monospace);font-size:11px;letter-spacing:.02em;line-height:1.2;color:#475583;white-space:nowrap}' +
    '.pb-bento__plus{position:absolute;z-index:1;left:60%;top:50%;width:24px;height:24px;margin:-12px 0 0 -12px;border-radius:999px;background:#fff;box-shadow:0 0 0 1px rgba(0,48,135,.14);display:grid;place-content:center;color:#003087;font:700 15px/1 var(--font-mono,"Space Mono",monospace);pointer-events:none}' +
    '.pb-bento .pb-bento__back{position:absolute;z-index:2;left:10px;bottom:10px;min-height:36px;padding:0 14px;border:1px solid rgba(0,52,211,.35);border-radius:999px;background:#fff;color:#0034d3;font:700 12px/1 var(--font-mono,"Space Mono",monospace);letter-spacing:.02em;cursor:pointer;transition:transform .15s ease,opacity .15s ease}' +
    '.pb-bento .pb-bento__back:hover{transform:translateY(-1px);opacity:.9}' +
    '.pb-bento .pb-bento__back:focus-visible{outline:2px solid #0034d3;outline-offset:2px}' +
    '.pb-bento--card{gap:4px;padding:4px}' +
    '.pb-bento--card .pb-bento__t{border-radius:6px}' +
    '.pb-bento--card .pb-bento__plus{width:18px;height:18px;margin:-9px 0 0 -9px;font-size:12px}' +
    '@media (max-width:749px){.pb-bento{gap:4px;padding:4px}.pb-bento__t{border-radius:6px}.pb-bento--card figcaption{display:none}.pb-bento__t figcaption{font-size:10px;left:6px;top:4px}}' +
    '@media (max-width:1023px){.pb-bento--card figcaption{display:none}}' +
    /* bundle slides in the product carousel (one per combo, after the photos) */
    '.pb-bslide__box{position:relative;width:100%;padding-bottom:100%;background:#fff;container-type:inline-size}' +
    '@container (max-width:280px){.pb-bslide__name{display:none}.pb-bslide__bar{justify-content:flex-end}}' +
    '.pb-bslide__box .pb-bento{bottom:46px}' +
    '.pb-bslide__bar{position:absolute;left:0;right:0;bottom:0;height:46px;display:flex;align-items:center;justify-content:space-between;gap:8px;padding:0 10px;box-sizing:border-box}' +
    '.pb-bslide__name{min-width:0;white-space:normal;line-height:1.2;font-family:var(--font-mono,"Space Mono",monospace);font-size:12px;letter-spacing:.02em;color:#003087}' +
    '.pb-bslide__save{flex:0 0 auto;display:inline-flex;align-items:center;min-height:30px;padding:0 12px;border-radius:999px;background:#fff;box-shadow:0 2px 10px rgba(0,48,135,.14),0 0 0 1px rgba(0,48,135,.06);color:#ad470e;font:700 12px/1 var(--pb-font-ui,"Inter Tight",system-ui,sans-serif);letter-spacing:.02em;white-space:nowrap}' +
    '.pb-bslide__save[hidden]{display:none}' +
    '.pb-bthumb{min-width:50px}' +
    '.pb-bthumb > button{position:relative;display:block;width:100%;height:0;padding:0 0 100%;border:0;border-radius:12px;overflow:hidden;background:#fff;cursor:pointer}' +
    '.pb-bthumb .pb-bento{gap:2px;padding:2px}' +
    '.pb-bthumb .pb-bento__t{border-radius:4px}' +
    '.pb-bthumb figcaption,.pb-bthumb .pb-bento__plus{display:none}' +
    '@media (max-width:749px){.pb-bslide__box .pb-bento{bottom:40px}.pb-bslide__bar{height:40px;padding:0 6px}.pb-bslide__name{font-size:11px}.pb-bslide__save{min-height:26px;padding:0 10px;font-size:11px}}' +
    /* collection card chips */
    '.pb-bc{display:flex;align-items:center;flex-wrap:wrap;gap:0 6px;margin:0 0 8px}' +
    '.pb-bc__k{flex-basis:100%;font-family:var(--font-mono,"Space Mono",monospace);font-size:11px;letter-spacing:.02em;color:#475583;white-space:nowrap}' +
    '.pb-bc .pb-bc__sw{position:relative;display:inline-grid;place-content:center;width:40px;height:40px;margin:0;padding:0;border:0;background:none;cursor:pointer}' +
    '.pb-bc .pb-bc__sw i{display:block;width:30px;height:22px;border-radius:7px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.18);transition:transform .15s ease}' +
    '.pb-bc .pb-bc__sw:hover i{transform:translateY(-1px)}' +
    '.pb-bc .pb-bc__sw[aria-pressed="true"] i{box-shadow:0 0 0 2px #fff,0 0 0 3.5px #0034d3}' +
    '.pb-bc .pb-bc__sw:focus-visible{outline:2px solid #0034d3;outline-offset:0;border-radius:8px}' +
    '@media (max-width:749px){.pb-bc .pb-bc__sw{width:44px;height:44px}}';

  function injectCss() {
    if (document.getElementById('pb-bento-css')) return;
    var s = document.createElement('style'); s.id = 'pb-bento-css'; s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function create(opts) {
    injectCss(); opts = opts || {};
    var b = document.createElement('div');
    b.className = 'pb-bento' + (opts.card ? ' pb-bento--card' : '');
    b.setAttribute('data-pb-bento', ''); b.hidden = true;
    b.innerHTML = '<figure class="pb-bento__t pb-bento__t--bag"><img alt="" data-bt="bag" decoding="async"></figure>' +
      '<span class="pb-bento__plus" aria-hidden="true">+</span>' +
      '<figure class="pb-bento__t"><img alt="" data-bt="sling" decoding="async"><figcaption>9" ITA Sling</figcaption></figure>' +
      '<figure class="pb-bento__t"><img alt="" data-bt="wallet" decoding="async"><figcaption>7" ITA Phone Wallet</figcaption></figure>' +
      (opts.back ? '<button type="button" class="pb-bento__back" data-pb-back>See bag photos</button>' : '');
    return b;
  }

  /* paint(el, {bag, sling, wallet}): el is any box holding img[data-bt=bag|sling|wallet] (the finder's .bf__bento
     or a .pb-bento). Needs the bag and at least one add-on; a missing add-on's tile is taken out. Returns shown. */
  function paint(b, set) {
    if (!b) return false;
    if (!set || !set.bag || (!set.sling && !set.wallet)) { b.hidden = true; return false; }
    ['bag', 'sling', 'wallet'].forEach(function (k) {
      var im = b.querySelector('[data-bt="' + k + '"]'); if (!im) return;
      var fig = im.closest('figure');
      if (set[k]) { if (im.getAttribute('src') !== set[k]) im.src = set[k]; if (fig) fig.hidden = false; }
      else if (fig && k !== 'bag') fig.hidden = true;
    });
    b.setAttribute('data-n', (set.sling ? 1 : 0) + (set.wallet ? 1 : 0));
    b.hidden = false;
    return true;
  }

  function fmt(cents, tpl) {
    var n = cents / 100, s = (cents % 100 === 0) ? Math.round(n).toLocaleString('en-AU') : n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    tpl = tpl || '$0'; var i = tpl.indexOf('0');
    return i < 0 ? '$' + s : tpl.slice(0, i) + s + tpl.slice(i + 1);
  }
  function json(root) { try { return JSON.parse(root.querySelector('script[data-pb-json]').textContent); } catch (e) { return null; } }
  function press(list, on, attr) { list.forEach(function (x) { var y = x === on; x.setAttribute(attr, y ? 'true' : 'false'); if (attr === 'aria-checked') x.tabIndex = y ? 0 : -1; }); }
  function radioKeys(list) {
    list.forEach(function (b) {
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0; if (!d) return;
        e.preventDefault(); var ok = list.filter(function (x) { return !x.disabled; }), n = ok[(ok.indexOf(b) + d + ok.length) % ok.length];
        if (n) { n.focus(); n.click(); }
      });
    });
  }

  /* ── product page the shared picker (assets/pb-bundle.js: Bag only / + 9" ITA Sling / + 7" ITA Phone Wallet / + both,
     each with its saving, set colour, line-item breakdown) drives: the bag's price dropping to its bundle price, the Add to
     cart label and total, the set slides in the carousel, express checkout, and one /cart/add.js for the set.
     ?set=sling|wallet|sling-wallet&colour=black (from the Preview's "View full product page") pre-selects the set. ── */
  function initProduct(root) {
    var d = json(root); if (!d) return;
    var PB = window.PBBundle;
    if (!PB || !PB.cfg().cols.length) { root._pbTry = (root._pbTry || 0) + 1; if (root._pbTry < 60) setTimeout(function () { initProduct(root); }, 100); return; }
    injectCss();
    var sid = root.getAttribute('data-sid'), mountEl = root.querySelector('[data-pbx-mount]') || root;
    var cols = PB.cfg().cols, opt = 'none', col = -1, cur = null, bento = null, host = null, hiddenByUser = false;
    var forms = (root.getAttribute('data-forms') || '').split(',');
    function variantId() { var i = document.getElementById('update-variant-' + sid); return i ? String(i.value) : ''; }
    function bagInfo() { return d.bag[variantId()] || d.bag[d.first] || { img: d.fallback, p: 0, c: 0 }; }
    function qty() { var f = document.getElementById(forms[0] || ''), q = f && f.querySelector('[name="quantity"]'); q = q || document.getElementById('Quantity-' + sid); return Math.max(1, parseInt(q && q.value, 10) || 1); }
    function need(o) { return PB.need(o); }
    function colFor(o) {
      if (col >= 0 && PB.colOk(cols[col], o)) return col; for (var i = 0; i < cols.length; i++) if (PB.colOk(cols[i], o)) return i;
      if (o === 'both') { var a = -1, b = -1; for (var j = 0; j < cols.length; j++) { if (a < 0 && cols[j].s && cols[j].s.ok) a = j; if (b < 0 && cols[j].w && cols[j].w.ok) b = j; } if (a >= 0 && b >= 0) return a; }
      return -1;
    }
    var BGRADE = /\bb[\s-]?grade\b/i;
    function isBG() { return BGRADE.test(bagInfo().t || ''); }
    /* B-grade takes no bundles while the same bag can be bought new; a bag sold only as B-grade keeps them */
    var NEW_OK = false; for (var bk in d.bag) { if (d.bag[bk] && d.bag[bk].a && !BGRADE.test(d.bag[bk].t || '')) NEW_OK = true; }
    function bagNow() { var b = bagInfo(); return { handle: (window.PBCampaign && window.PBCampaign.pageHandle) || '', name: d.name || d.title, price: b.p, compare: b.c, qty: qty(), elig: d.elig !== false, solo: NEW_OK && BGRADE.test(b.t || ''), img: b.ti || b.img || d.fallback, colour: (b.t && !/^(default title|bag only)/i.test(b.t) ? b.t : '') + ' ' + (d.title || '') }; }
    /* the add-ons pick their colours on their own (sling and wallet rows): the chosen ones when in stock, else ci */
    function setFor(o, ci) {
      var n = need(o), bag = bagInfo(), c0 = cols[ci] || {};
      var cs = cur && cur.sl && cur.sl.ok ? cur.sl : { name: c0.name, img: c0.s && c0.s.img }, cw = cur && cur.wl && cur.wl.ok ? cur.wl : { name: c0.name, img: c0.w && c0.w.img };
      return { bag: bag.img || d.fallback, sling: n.sling ? cs.img : '', wallet: n.wallet ? cw.img : '', name: n.sling && n.wallet && cs.name !== cw.name ? cs.name + ' / ' + cw.name : (n.sling ? cs : cw).name };
    }

    /* ── carousel mode: each combo is an extra slide at the END of the product carousel, with its own thumbnail ── */
    var gal = null, galTries = 0;
    function combos() { return ['sling', 'wallet', 'both'].filter(function (o) { return colFor(o) >= 0; }); }
    function splideEl() { var el = document.getElementById('x-product-' + sid); return el && el.splide ? el : null; }
    function hasSlider() { return !!document.getElementById('x-product-' + sid); }
    function buildGallery() {
      if (gal) return gal;
      var el = splideEl(); if (!el) return null;
      var list = combos(); if (!list.length) return null;
      var tRoot = document.getElementById('x-product-thumbnail-' + sid), tList = tRoot && tRoot.firstElementChild;
      var g = { el: el, map: {}, order: list }, slides = [];
      list.forEach(function (o) {
        var s = document.createElement('div');
        s.className = 'splide__slide x-splide-slide product-media pb-bslide'; s.setAttribute('data-pb-slide', o);
        s.innerHTML = '<div class="pb-bslide__box"><div class="pb-bslide__bar"><span class="pb-bslide__name"></span><span class="pb-bslide__save" hidden></span></div></div>';
        var b = create({}); s.firstChild.insertBefore(b, s.firstChild.firstChild); b.setAttribute('role', 'img');
        slides.push(s); g.map[o] = { slide: s, bento: b };
        if (tList) {
          var th = document.createElement('div');
          th.className = 'x-thumbnail media-thumbnail pb-bthumb relative select-none opacity-30'; th.setAttribute('data-pb-thumb', o);
          th.innerHTML = '<button type="button"></button>';
          th.firstChild.setAttribute('aria-label', 'Show the bundle: bag ' + (o === 'both' ? 'with the 9 inch ITA Sling and 7 inch ITA Phone Wallet' : o === 'sling' ? 'with the 9 inch ITA Sling' : 'with the 7 inch ITA Phone Wallet'));
          var tb = create({ card: true }); th.firstChild.appendChild(tb); tList.appendChild(th); g.map[o].tb = tb;
          th.addEventListener('click', function () { go(o); });
        }
      });
      gal = g;
      el.splide.add(slides);
      paintGallery();
      if (opt !== 'none') go(opt);
      return gal;
    }
    function slideIndex(o) { if (!gal || !gal.map[o]) return -1; var sl = gal.el.splide.Components.Slides.get(true); for (var i = 0; i < sl.length; i++) if (sl[i].slide === gal.map[o].slide) return sl[i].index; return -1; }
    /*  moving the gallery to the bundle slide must never move the page (the thumbnail rail sync scrolled the window) */
    function go(o) {
      var i = o === 'none' ? 0 : slideIndex(o); if (!(gal && i >= 0 && gal.el.splide.index !== i)) return;
      var y = window.scrollY, hold = function () { if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y); };
      gal.el.splide.go(i); hold(); requestAnimationFrame(hold); setTimeout(hold, 120); setTimeout(hold, 400);
    }
    function paintGallery() {
      if (!gal) return;
      gal.order.forEach(function (o) {
        var ci = colFor(o), m = gal.map[o]; if (ci < 0) return;
        var set = setFor(o, ci), n = need(o), k = PB.calc(PB.linesFor(bagNow(), o, cols[ci]));
        PBBento.paint(m.bento, set); if (m.tb) PBBento.paint(m.tb, set);
        var what = n.sling && n.wallet ? 'Sling and wallet' : n.sling ? 'With the sling' : 'With the wallet';
        var nm = m.slide.querySelector('.pb-bslide__name'), bd = m.slide.querySelector('.pb-bslide__save');
        nm.textContent = what + ', ' + set.name;
        if (k.was > k.now) { bd.textContent = 'Save ' + PB.money(k.was - k.now); bd.hidden = false; } else { bd.textContent = ''; bd.hidden = true; }
        m.bento.setAttribute('aria-label', d.title + (n.sling ? ' + 9" ITA Sling' : '') + (n.wallet ? ' + 7" ITA Phone Wallet' : '') + ', ' + set.name);
      });
    }
    function whenGallery() { if (buildGallery() || !hasSlider() || galTries++ > 80) return; setTimeout(whenGallery, 250); }

    /* ── overlay mode: only when the page has no carousel at all (e.g. a stacked gallery) ── */
    function findHost() {
      var pm = document.getElementById('product-media-' + sid); if (!pm) return null;
      var c = [pm.querySelector('#stacked-' + sid + ' .product-media-item'), pm.querySelector('.splide__track')];
      for (var i = 0; i < c.length; i++) if (c[i] && c[i].offsetWidth > 0 && c[i].offsetHeight > 0) return c[i];
      return null;
    }
    function ensureBento() {
      var h = findHost(); if (!h) return null;
      if (bento && host === h) return bento;
      if (!bento) {
        bento = create({ back: true });
        bento.querySelector('[data-pb-back]').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hiddenByUser = true; bento.hidden = true; });
        ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) { bento.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
      }
      if (getComputedStyle(h).position === 'static') h.style.position = 'relative';
      h.appendChild(bento); host = h; return bento;
    }

    /*  express checkout buys only the bag, so it hides while a bundle is chosen.
        M-8BED: with the free wallet offer on, 'bag' is Bag only (not a bundle), so it shows there too; with the gift picked,
        assets/pb-free-wallet.js payGuard sends the tap through the cart so the wallet comes along */
    function express() {
      var show = opt === 'none' || (fwOn && opt === 'bag');
      var ex = document.querySelectorAll('#shopify-section-' + sid + ' .payment-button-container, #x-payment-button-' + sid);
      for (var i = 0; i < ex.length; i++) { ex[i].style.display = show ? '' : 'none'; ex[i].setAttribute('aria-hidden', show ? 'false' : 'true'); }
    }
    /* the bag's own price drops to its bundle price (was = regular price, now = sale price less the bundle discount) */
    var shownNow = 0;
    function priceDrop(s) {
      var el = document.getElementById('price-' + sid); if (!el) return;
      var hostEl = el.querySelector(':scope > .pbx-pd-host');
      if (!s.calc) { if (hostEl) hostEl.remove(); el.classList.remove('pbx-pd-on'); shownNow = 0; return; }
      var l = s.calc.lines[0], from = shownNow || s.bag.price;
      if (!hostEl) { hostEl = document.createElement('div'); hostEl.className = 'pbx-pd-host'; el.insertBefore(hostEl, el.firstChild); }
      hostEl.innerHTML = PB.priceHTML(l.unitWas, l.unitNow, 'Bundle price');
      hostEl.setAttribute('aria-label', 'Bag price in this bundle ' + PB.moneyPage(l.unitNow) + ', was ' + PB.moneyPage(l.unitWas));
      el.classList.add('pbx-pd-on');
      PB.tween(hostEl.querySelector('[data-pbx-num]'), from, l.unitNow);
      shownNow = l.unitNow;
    }
    /* the add buttons say what they add: "Add bundle to bag – $467.50" (the theme's own label comes back for Bag only) */
    var atcIds = ['x-atc-button-' + sid, 'x-atc-button-sticky-' + sid];
    function atcLabel(s) {
      atcIds.forEach(function (bid) {
        var b = document.getElementById(bid); if (!b) return;
        var t = b.querySelector('.x-atc-text'); if (!t) return;
        var lab = b.querySelector('.pbx-atc');
        if (!lab) { lab = document.createElement('span'); lab.className = 'pbx-atc button-text w-fit pt-0.5 pb-0.5'; t.parentNode.insertBefore(lab, t.nextSibling); }
        if (s.calc) { lab.textContent = 'Add bundle to bag – ' + PB.moneyPage(s.total); b.classList.add('pbx-atc-on'); }
        else { lab.textContent = ''; b.classList.remove('pbx-atc-on'); }
      });
    }
    function onChange(s, why) {
      cur = s; opt = s.opt;
      express(); paintGallery(); priceDrop(s); atcLabel(s);
      if (why === 'opt' || why === 'colour' || why === 'set') { hiddenByUser = false; buildGallery(); go(opt); }
      if (opt === 'none' || !s.col) { if (bento) bento.hidden = true; return; }
      if (gal || hasSlider() || hiddenByUser) return;
      var b = ensureBento(); if (!b) return;
      var n = need(opt);
      PBBento.paint(b, { bag: bagInfo().img || d.fallback, sling: n.sling ? s.col.s.img : '', wallet: n.wallet ? (s.wcol || s.col).w.img : '' });
      b.setAttribute('aria-label', d.title + (n.sling ? ' + 9" ITA Sling' : '') + (n.wallet ? ' + 7" ITA Phone Wallet' : '') + ', ' + s.col.name);
      b.setAttribute('role', 'img');
    }
    var ini = PB.fromUrl();
    /* M-9213: while the free wallet comes with this bag, the paid 7" wallet options are not offered (no wallet both free and
       bundle-discounted): Bag only and Bag + 9" sling stay, each with the free wallet from the choice above */
    var FW = window.PBFreeWallet, fwRoot = root.querySelector('[data-pbfw]');
    var fwOn = false, fwD = null; if (fwRoot) { try { fwD = JSON.parse(fwRoot.querySelector('script[data-pbfw-json]').textContent); fwOn = !!fwD.ok; } catch (e) { fwOn = false; } }
    /* M-E1F2 / M-B87E: with the free wallet on, ONE list of three options under "Choose your option":
       Bag + free wallet (picked first), Bag + 9" mini ITA sling (free wallet included, solid "Save an extra 10%" badge),
       Bag only (no wallet, same price as the first). The separate wallet block and the 10% subline are hidden; the list
       drives the free wallet choice (assets/pb-free-wallet.js setGift). */
    /* M-C8F6 (30 Oct 2026): now a short list of two, Bag + free wallet (first, picked) and Bag only, both at the bag's own
       price; bundles moved to their own "Bundle and save 10%" section under Add to cart (assets/pb-fw-bundle.js) */
    var mopts = fwOn ? {
      opts: ['none', 'bag'],
      labels: { none: 'Bag + free wallet', bag: 'Bag only' },
      subs: { none: fwD.was ? 'Worth ' + PB.esc(PB.moneyShort(fwD.was)) : 'Free with your bag', bag: 'No wallet' },
      gift: { img: fwD.gimg || '', opts: ['none'] }
    } : {};
    if (fwOn) root.classList.add('is-fw1');
    var cgCur = null, cgNames = '', cgWas = 0;
    var incEl = root.querySelector('[data-pb-inc]'), incBase = null;
    try { incBase = JSON.parse(root.querySelector('[data-pb-inc-json]').textContent); } catch (e) { incBase = null; }
    /* M-46D0: the deal's detail lives in What's included, one (i) tip per row; wording from the live product pages.
       M-CDD9/M-00A6: every row on every bag: the item's photo on top, then short bullets. Bag photo = this variant's; the rest from snippets/pb-included-json */
    function worth(c) { return c ? 'Worth ' + PB.moneyShort(c) : ''; }
    function incW(u) { return u ? String(u).replace(/([?&]width=)\d+/, '$1320') : ''; }
    function incL(k) { var T = (incBase && incBase.tips) || {}; return T[k] ? String(T[k]).split('~~') : []; }
    function incPic(kind) { var P = (incBase && incBase.pics) || {}, by = (P.by && P.by[kind]) || {}, c = String(bagInfo().t || '').split(' ')[0].toLowerCase(); return by[c] || P[kind] || ''; }
    function incTip(t, i) {
      var b = bagInfo();
      if (i === 0) return { img: incW(b.ti || b.img), b: incL('bag') };
      if (/^Free .*wallet/i.test(t)) return { img: incW(fwD && fwD.gimg), head: worth(fwD && fwD.was), b: ['A window for 8 to 10 pins', 'Takes phones up to an iPhone 17 Pro Max', 'Three card slots and a wrist strap', 'Use it on its own or inside your bag'] };
      if (/^Free .*lanyard/i.test(t)) { var g = ((cgCur && cgCur.gifts) || []).filter(function (x) { return x.img; })[0]; return { img: incW(g && g.img), head: worth(cgWas), b: ['Adjustable cross-body phone strap, about 54 to 82 cm', 'Magnetic twist buckle, 5 nylon loops and a metal swivel clip', 'Clips onto a Pinbuds phone tether in your case'] }; }
      if (/warranty/i.test(t)) return { b: ['Covers faults in materials and workmanship under normal everyday use', 'Lasts 1 year from delivery', 'Does not cover normal wear and tear, accidents, misuse, deliberate damage or changes made to the bag'] };
      if (incBase && t === incBase.strap) return { img: incPic('strap'), b: incL('strap') };
      if (/^(\d+ )?pin inserts?$/i.test(t)) return { img: incPic('pad'), b: incL('pad') };
      if (/installation foam/i.test(t)) return { img: incPic('foam'), b: incL('foam') };
      return null;
    }
    function paintInc(s) {
      if (!incEl || !incBase || !PB.incHTML) return;
      var b = bagInfo(), t = b.t && !/^(default title|bag only)/i.test(b.t) ? String(b.t).replace(/\s*[\/|-]?\s*b[\s-]?grade.*$/i, '').replace(/\s*\/\s*new$/i, '') : '';
      var F = window.PBFreeWallet, fw = fwRoot && !isBG() && F && F.gift && F.gift() ? F.giftName() : '';
      incEl.innerHTML = PB.incHTML(incBase, s || (api && api.state()), { name: d.name || '', colour: t, fw: fw ? fw.replace(/^7" ITA Phone Wallet/i, '7" mini ITA phone wallet') : '', fwWas: fw && fwD ? fwD.was : 0, extra: fw && cgNames ? ['Free ' + cgNames + (cgWas ? ' (worth ' + PB.moneyShort(cgWas) + ')' : '')] : [], bgrade: BGRADE.test(b.t || ''), tip: incTip });
    }
    var api = PB.mount(mountEl, Object.assign({ heading: false, thumbs: true, bag: bagNow, initial: ini, onChange: function (s, why) { if (fwOn && window.PBFreeWallet && window.PBFreeWallet.setGift) window.PBFreeWallet.setGift(s.opt !== 'bag' && !isBG()); onChange(s, why); if (fwOn) cgPaint(cgCur); paintInc(s); } }, mopts));
    if (fwRoot) fwRoot.addEventListener('pbfw:change', function () { paintInc(); });
    paintInc();
    if (!api) return;
    root._pbx = api;

    /* M-C25B (PB-1338): while a campaign token with free gifts (the early bird lanyard, campaign_token gift_variants) is on
       for this bag, those gifts join the free wallet option: label "Bag + free wallet + free lanyard", the gift named in the
       subline and its photo in the cluster (small, little overlap). The cart side is assets/pb-free-wallet.js (cg), which adds
       the gift lines with every campaign bag, Bag only included, so Bag only says so too. Token gone: wallet only again. */
    function cgNoun(g) { return /lanyard/i.test(g.name || '') ? 'lanyard' : 'gift'; }
    function cgPaint(cg) {
      /* M-6DF4: B-grade gets no free wallet or lanyard on any bag: the one option left is plain Bag only */
      var bg = isBG();
      var gifts = !bg && cg && cg.gifts ? cg.gifts.filter(function (g) { return g && g.ok; }) : [];
      var x = mountEl.querySelector('[data-pb-opt="none"]'), xb = mountEl.querySelector('[data-pb-opt="bag"]');
      if (!x) return;
      var n = x.querySelector('.pb-bndl__n'), th = x.querySelector('.pb-bndl__th'), sub = x.querySelector('.pb-bndl__sub2');
      var label = bg ? 'Bag only' : 'Bag + free wallet' + gifts.map(function (g) { return ' + ' + cgNoun(g); }).join('');
      cgWas = gifts.reduce(function (a, g) { return a + (+g.was || 0); }, 0);
      if (n && n.firstChild && n.firstChild.nodeType === 3 && n.firstChild.nodeValue !== label) n.firstChild.nodeValue = label;
      var names = gifts.map(function (g) { return String(g.name || '').split(',')[0]; }).join(' and ');
      /* the subline stays short (the option row is narrow on phones): "blue phone lanyard"; What's included keeps the full name */
      var shortN = gifts.map(function (g) { var c = String(g.name || '').split(',')[1]; c = c ? c.trim().toLowerCase() + ' ' : ''; return cgNoun(g) === 'lanyard' ? c + 'phone lanyard' : String(g.name || '').split(',')[0]; }).join(' + ');
      /* M-D8C4: one calm line in the pill; each gift's detail is a tip under What's included */
      if (sub) { var wv = (+fwD.was || 0) + cgWas, subT = bg ? 'No free gifts with B-grade' : wv ? 'Worth ' + PB.moneyShort(wv) : 'Free with your bag'; if (sub.textContent !== subT) sub.textContent = subT; }
      if (th) {
        var have = [].map.call(th.querySelectorAll('[data-th-cg]'), function (im) { return im.getAttribute('src'); }).join('|');
        var want = gifts.filter(function (g) { return g.img; }).map(function (g) { return g.img; });
        if (have !== want.join('|')) {
          [].forEach.call(th.querySelectorAll('[data-th-cg]'), function (im) { im.parentNode.removeChild(im); });
          want.forEach(function (src) { var im = document.createElement('img'); im.alt = ''; im.decoding = 'async'; im.setAttribute('data-th-cg', ''); im.src = src; th.appendChild(im); });
        }
        th.classList.toggle('is-cg', want.length > 0);
        th.classList.toggle('is-nogift', bg);
      }
      /* M-07D2: the gift option's saving counts the free gifts: bag saving + each gift's value, per bag */
      var sv = x.querySelector('.pb-bndl__s');
      if (sv && !bg && sv.textContent !== sv.getAttribute('data-pb-shown')) {
        var mt = sv.textContent.match(/[\d,]+(?:\.\d+)?/), base = mt ? Math.round(parseFloat(mt[0].replace(/,/g, '')) * 100) : 0, gv = ((+fwD.was || 0) + cgWas) * qty();
        if (gv) { sv.textContent = 'Save ' + PB.money(base + gv); sv.setAttribute('data-pb-shown', sv.textContent); }
      }
      var bs = xb && xb.querySelector('.pb-bndl__sub2'), bt = gifts.length ? 'No free gifts' : 'No wallet';
      if (bs && bs.textContent !== bt) bs.textContent = bt;
      cgNames = names;
    }
    function cgCheck() {
      var C = window.PBCampaign, F = window.PBFreeWallet;
      /* PB-1381: an always-on deal on this bag shows like a campaign gift, with no token */
      if (fwD.always && fwD.always.length) { if (!cgCur) { cgCur = { gifts: fwD.always, pids: [+fwD.pid] }; cgPaint(cgCur); paintInc(); } return; }
      var tok = C && C.state && C.state.active && C.state.rec ? C.state.rec.token : '';
      if (!tok || !F || !F.cgFor) { if (cgCur) { cgCur = null; cgPaint(null); paintInc(); } return; }
      F.cgFor(tok).then(function (cg) {
        var on = cg && !cg.err && cg.pids && cg.pids.indexOf(+fwD.pid) >= 0 ? cg : null;
        if (on === cgCur) return;
        cgCur = on; cgPaint(on); paintInc();
      }, function () {});
    }
    if (fwOn && fwD && fwD.pid) {
      document.addEventListener('pb:campaign-applied', cgCheck);
      document.addEventListener('pb:campaign-ended', cgCheck);
      if (window.PBCampaign && window.PBCampaign.ready && window.PBCampaign.ready.then) window.PBCampaign.ready.then(cgCheck, function () {});
      cgCheck();
    }

    /* New / B-grade switch (snippets/pb-bundle-bento): it sets the product's own Deal option, whose picker is hidden, so the
       theme's variant logic runs as before; the switch then follows the chosen variant */
    var cond = root.querySelector('[data-pb-cond]');
    /* M-BBE1: the theme loads the tapped variant over the network (a second or more). Until it has, the switch keeps showing the
       tap: redrawing from the old variant is what made it flick back. condV = the option value asked for, null = nothing pending */
    var condV = null, condN = 0, condT = 0;
    function condSet(v) { var s = document.getElementById('Option-' + sid + '-0'); if (!s || s.value === v) return; s.value = v; s.dispatchEvent(new Event('change', { bubbles: true })); }
    function syncCond() {
      if (!cond) return;
      var bg = BGRADE.test(bagInfo().t || '');
      if (condV !== null) {
        if (BGRADE.test(condV) !== bg) { var s0 = document.getElementById('Option-' + sid + '-0'); if (s0 && s0.value !== condV && condN++ < 3) condSet(condV); return; }
        condV = null; clearTimeout(condT);
      }
      [].forEach.call(cond.querySelectorAll('[data-pb-cond-v]'), function (b) { var on = BGRADE.test(b.getAttribute('data-pb-cond-v')) === bg; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
    }
    /* M-7AE1: load both variants' section HTML up front into the theme's own cache (assets/variant-select.js cachedResults, same
       link it builds), so a tap swaps price, stock and options at once instead of waiting a second on the network */
    var condWarmed = false, condWarmN = 0;
    function condWarm() {
      if (condWarmed) return;
      var s = document.getElementById('Option-' + sid + '-0'), pk = s && s.closest('.variant-selects-main'), c = pk && pk._x_dataStack && pk._x_dataStack[0];
      if (!c || !c.cachedResults) { if (condWarmN++ < 30) setTimeout(condWarm, 300); return; }
      condWarmed = true;
      [].forEach.call(s.options, function (o) {
        var id = o.dataset.optionValueId, u = o.dataset.productUrl || pk.dataset.url; if (!id || !u) return;
        var link = u + '?section_id=' + c.handleSectionId + '&option_values=' + id;
        if (c.cachedResults[link]) return;
        fetch(link, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
          if (t && !c.cachedResults[link]) c.cachedResults[link] = new DOMParser().parseFromString(t, 'text/html');
        }).catch(function () {});
      });
    }
    if (cond) {
      if (window.requestIdleCallback) requestIdleCallback(condWarm, { timeout: 1500 }); else setTimeout(condWarm, 800);
      cond.addEventListener('pointerenter', condWarm); cond.addEventListener('touchstart', condWarm, { passive: true });
      cond.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-pb-cond-v]'); if (!b || b.disabled) return;
        var s = document.getElementById('Option-' + sid + '-0'), v = b.getAttribute('data-pb-cond-v'); if (!s) return;
        [].forEach.call(cond.querySelectorAll('[data-pb-cond-v]'), function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        condV = v; condN = 0; clearTimeout(condT); condT = setTimeout(function () { condV = null; syncCond(); }, 6000);
        if (s.value === v) return;
        /* the theme's variant code listens once Alpine has set the picker up: wait for it rather than lose the tap */
        var pk = s.closest('.variant-selects-main'), n = 0;
        (function go() {
          if (pk && !pk._x_dataStack && n++ < 50) { setTimeout(go, 200); return; }
          var s2 = document.getElementById('Option-' + sid + '-0'); if (!s2 || s2.value === v && s2 !== s) return;
          s2.value = v; s2.dispatchEvent(new Event('change', { bubbles: true }));
          /* with condWarm's copy the theme has already swapped everything by here: repaint now, not 80 ms later */
          try { if (api) api.refresh(); syncCond(); } catch (e2) {}
        })();
      });
      cond.addEventListener('keydown', function (e) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
        var l = [].slice.call(cond.querySelectorAll('[data-pb-cond-v]:not([disabled])')), i = l.indexOf(document.activeElement); if (i < 0 || l.length < 2) return;
        e.preventDefault(); var n = l[(i + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? l.length - 1 : 1)) % l.length]; n.focus(); n.click();
      });
      syncCond();
    }
    /* the bag tile and every price follow the chosen variant and quantity */
    function later() { setTimeout(function () { api.refresh(); syncCond(); }, 80); }
    document.addEventListener('eurus:product-page-variant-select:updated:' + sid, later);
    document.addEventListener('eurus:product:quantity-changed-' + sid, later);
    var info = document.getElementById('ProductInfo-' + sid);
    if (info) { info.addEventListener('change', later); info.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') later(); }); }
    var pm = document.getElementById('product-media-' + sid);
    if (pm) pm.addEventListener('click', function (e) {
      if (gal || opt === 'none' || !bento || bento.hidden) return;
      if (e.target.closest('.x-thumbnail,.splide__arrow')) { hiddenByUser = true; bento.hidden = true; }
    });
    var resizeT; window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(function () { if (!gal && opt !== 'none' && !hiddenByUser && findHost() !== host) onChange(api.state(), 'resize'); }, 200); });
    /* the theme re-renders the price block on a variant change: put the bundle price back */
    var pEl = document.getElementById('price-' + sid);
    if (pEl && window.MutationObserver) new MutationObserver(function () { if (cur && cur.calc && !pEl.querySelector(':scope > .pbx-pd-host')) { shownNow = 0; priceDrop(api.state()); } }).observe(pEl, { childList: true });

    /* add to cart with a bundle: one /cart/add.js (bag x quantity + add-ons), then the drawer, like snippets/pb-quick-add */
    function bundleItems() {
      var s = api.state(); if (!s.calc || !s.items.length) return null;
      var f = document.getElementById(forms[0] || ''); var fd = f ? new FormData(f) : null;
      var vid = parseInt((fd && fd.get('id')) || variantId(), 10); if (!vid) return null;
      var q = parseInt((fd && fd.get('quantity')) || '1', 10) || 1;
      var out = [{ id: vid, quantity: q }].concat(s.items);
      /* PB-1324: the free wallet choice (assets/pb-free-wallet.js) adds its gift line to the same add */
      return window.PBFreeWallet ? window.PBFreeWallet.decorate(out) : out;
    }
    function addBundle(btn, items) {
      var A = window.Alpine && window.Alpine.store ? window.Alpine : null;
      btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.6'; btn.disabled = true;
      function done() { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; btn.disabled = false; }
      var body = { items: items };
      try { var ch = A && A.store('xCartHelper'); if (ch && ch.getSectionsToRender) { body.sections = ch.getSectionsToRender().map(function (x) { return x.id; }); body.sections_url = location.pathname; } } catch (e) {}
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var er = new Error(j && (j.description || j.message) || r.status); er.desc = j && j.description; throw er; } return j; }); })
        .then(function (data) {
          var opened = false;
          try {
            var ch2 = A && A.store('xCartHelper');
            if (data && data.sections && ch2 && ch2.reRenderSections) {
              ch2.reRenderSections(data.sections);
              var bubble = document.querySelector('#cart-icon-bubble span'); if (bubble) ch2.currentItemCount = parseInt(bubble.innerHTML, 10) || ch2.currentItemCount;
            }
          } catch (e) {}
          try { var mc = A && A.store('xMiniCart'); if (mc) { if (!data || !data.sections) { mc.needReload = true; if (mc.reLoad) mc.reLoad(); } mc.openCart(); opened = true; } } catch (e) {}
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          done();
          if (!opened) location.href = '/cart';
        })
        .catch(function (err) {
          done();
          var nt = root.querySelector('[data-pb-note]');
          if (nt) { nt.hidden = false; nt.textContent = (err && err.desc) || 'That bundle could not be added. Please try again.'; }
        });
    }
    window.addEventListener('click', function (e) {
      if (opt === 'none') return;
      var btn = e.target.closest && e.target.closest('button'); if (!btn || atcIds.indexOf(btn.id) < 0) return;
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var items = bundleItems(); if (!items) return;
      e.preventDefault(); e.stopImmediatePropagation();
      window.__pbLastBundleAdd = items;
      addBundle(btn, items);
    }, true);

    whenGallery();
  }

  /* ── collection card: colour chips swap the card photo to the bento (built on first tap) ── */
  function initCard(row) {
    var d = json(row); if (!d || !d.cols || !d.cols.length) return;
    var card = row.closest(row.getAttribute('data-root') || '.card-product') || row.parentElement;
    var chips = [].slice.call(row.querySelectorAll('[data-pb-col]'));
    var bento = null, link = null, href = '';
    function hostEl() { return card && card.querySelector(row.getAttribute('data-host') || 'a.link-product-variant.x-labels-data'); }
    function show(ci) {
      var h = hostEl(); if (!h) return;
      if (!bento) {
        bento = create({ card: true });
        if (getComputedStyle(h).position === 'static') h.style.position = 'relative';
        h.appendChild(bento);
        link = h.tagName === 'A' ? h : h.closest('a'); href = link ? link.getAttribute('href') : '';
      }
      chips.forEach(function (c, i) { c.setAttribute('aria-pressed', i === ci ? 'true' : 'false'); });
      if (ci < 0) { bento.hidden = true; if (link) link.setAttribute('href', href); return; }
      var c = d.cols[ci];
      PBBento.paint(bento, { bag: d.bag, sling: c.s, wallet: c.w });
      if (link) link.setAttribute('href', window.PBBundle ? window.PBBundle.link(href, { opt: 'both', colour: c.name }) : href.split('#')[0] + '#bundle=both-' + c.name.toLowerCase());
    }
    /*  the chip matching the bag's colour comes first (Beige for beige / brown bags, else Black) and, while the
       shopper has not picked a set colour, follows the card's colour swatches (event pb:card-colour on the card) */
    var manual = false, tone = window.PBBundle && window.PBBundle.tone ? window.PBBundle.tone : function (t) { return /beige|ivory|cream|brown|chocolate|tan\b|sand|camel|khaki/i.test(t || '') ? 'beige' : 'black'; };
    function prefIdx(t) { var w = tone(t); for (var i = 0; i < d.cols.length; i++) if (String(d.cols[i].name).toLowerCase().indexOf(w) === 0) return i; return -1; }
    function order(t) {
      var pi = prefIdx(t); if (pi < 0 || !chips[pi]) return pi;
      var first = row.querySelector('[data-pb-col]'); if (first && first !== chips[pi]) first.parentNode.insertBefore(chips[pi], first);
      return pi;
    }
    order(d.tone);
    if (card) card.addEventListener('pb:card-colour', function (e) {
      var t = (e.detail && e.detail.name) || '', pi = order(t + ' ' + (d.tone || ''));
      if (!manual && bento && !bento.hidden && pi >= 0) show(pi);
    });
    chips.forEach(function (b, i) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); manual = true;
        show(b.getAttribute('aria-pressed') === 'true' ? -1 : i);
      });
    });
  }

  function boot(scope) {
    injectCss();
    [].slice.call((scope || document).querySelectorAll('[data-pb-bundle]:not([data-pb-ready])')).forEach(function (el) {
      el.setAttribute('data-pb-ready', '');
      try { if (el.getAttribute('data-pb-bundle') === 'product') initProduct(el); else initCard(el); } catch (e) { if (window.console) console.warn('pb-bundle-bento', e); }
    });
  }

  window.PBBento = { create: create, paint: paint, boot: boot, fmt: fmt };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  /* cards that arrive later (filters, infinite scroll, quick view) */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (window.MutationObserver) {
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { if (document.querySelector('[data-pb-bundle]:not([data-pb-ready])')) boot(); }, 120); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
